export default __webpack_public_path__ + "static/media/grenade-launcher.c6dff229.svg";